'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var CheckIcon = function CheckIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M15.379 3.566L5.74 13.203.8 8.262l1.767-1.768L5.74 9.668l7.871-7.87z'
    }) : _react2.default.createElement('path', {
      d: 'M2 8.689l.637-.636L5.5 10.727l8.022-7.87.637.637L5.5 12z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M22 6.332L9.29 19.04l-6.516-6.516 2.331-2.332 4.185 4.186L19.669 4z'
    }) : _react2.default.createElement('path', {
      d: 'M4.581 13.276l.637-.636 3.288 3.098 10.073-9.92.637.637L8.506 17.01z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M29.835 7.688l-18.072 18.07-9.265-9.266 3.314-3.314 5.951 5.951L26.521 4.373z'
  }) : _react2.default.createElement('path', {
    d: 'M12.5 22.142L6.59 16.42l.636-.636L12.5 20.87 25.721 7.8l.637.637L12.5 22.142'
  }));
};

exports.default = CheckIcon;